import { api } from '@/api/client'
import { toast } from '@crosscode/gravity-components'
import type { RemoteConnection } from '@/features/remote/types'
import { DEFAULT_TUNNEL_URL } from '@/features/remote/types'

interface RemoteAccessResponse {
  connections?: RemoteConnection[]
  notification?: { type?: string; message?: string }
}

function normalizeConn(conn: RemoteConnection): RemoteConnection {
  return {
    ...conn,
    tunnelUrl: conn.tunnelUrl || DEFAULT_TUNNEL_URL,
  }
}

export async function fetchTerminalRemote(
  terminalId: string | number,
  kind: 'SSH' | 'VNC',
): Promise<RemoteConnection | null> {
  try {
    const data = await api<RemoteAccessResponse>(
      `/api/remote-access/${terminalId}/terminal?embed=1`,
    )
    if (data.notification?.type === 'error' && data.notification.message) {
      toast.error(data.notification.message)
      return null
    }
    const connections = data.connections || []
    const conn = connections.find((c) => (c.label || '').toUpperCase().includes(kind))
    if (!conn?.connectionToken && !conn?.url) {
      toast.error(`Подключение ${kind} не найдено`)
      return null
    }
    return normalizeConn(conn)
  } catch (err) {
    toast.error(err instanceof Error ? err.message : 'Ошибка удалённого доступа')
    return null
  }
}
